import { useMutation } from '@tanstack/vue-query'

export default () => {
  const authStore = useAuthStore()
  return useMutation({
    mutationFn: async ({ date }: { date: string }) =>
      await $fetch<string>(`/api/user/${authStore.user!.id}/agent-call`, {
        method: 'POST',
        body: JSON.stringify({ date }),
        headers: {
          Authorization: `Bearer ${authStore.token}`,
        },
      }),
    onSuccess: () => {
      authStore.updateUser({
        ...authStore.user!,
        bookedFirstCall: true,
      })
    },
  })
}
